﻿import creator from '../elementCreator';
import globals from '../globals';
"use strict";
var privateFns, clickFns, intranett;
var urlBase = {partList: {}, addPart: {}};
privateFns = {
	sharePage: function(){
		var el = creator.createDiv({id: "share-page", css: "drop_downs"});
		el.setAttribute("data-enhance", "false");
		var userMessage1 = creator.createDiv({css: "user-message-intranett", text: "OBS: Intranettversjonen fungerer bare internt i kommunen"});
		el.appendChild(userMessage1);
		let shareControls = creator.createDiv({id: "share-controls", css: "drop_downs"});
		let pointCheckBox = creator.createInput({type: "checkbox", id: "pointNoMark", group: "point", name: "Punkt"});
		pointCheckBox.checked = true;
		shareControls.appendChild(pointCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "pointNoMark", text: "Punkt"}));
		shareControls.appendChild(creator.createBr({}));
		let pointMarkCheckBox = creator.createInput({type: "checkbox", id: "pointMark", group: "point", name: "Punkt markert"});
		shareControls.appendChild(pointMarkCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "pointMark", text: "Punkt markert"}));
		shareControls.appendChild(creator.createBr({}));
		let minCheckBox = creator.createInput({type: "checkbox", id: "min", group: "min", name: "Min"});
		shareControls.appendChild(minCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "min", text: "Minimer"}));
		shareControls.appendChild(creator.createBr({}));
		let modeCheckBox = creator.createInput({type: "checkbox", id: "mode", group: "mode", name: "Mode"});
		minCheckBox.checked = true; 
		
		el.appendChild(shareControls);
		el.appendChild(creator.createDiv({id: "shareUrl", css: "share-url"}));
		var userMessage2 = creator.createDiv({css: "user-message-intranett", text: "Lenken over åpner i et nytt vindu. Der kan du lagre bokmerke eller snarveg til det du ser på skjermen nå."});
		el.appendChild(userMessage2);
		var span = creator.createSpan({text: "Del via: "});
		el.appendChild(span);
		
		pointCheckBox.onclick = function(e){
			//var urlBase = {partList: {}, addPart: {}};
			urlBase.partList.point = "&north=" + globals.map.getView().getCenter()[1]  + "&east=" + globals.map.getView().getCenter()[0]; 
			urlBase.addPart.point = e.target.checked;
			if(e.target.checked){
				urlBase.addPart.pointMark = !e.target.checked;
				pointMarkCheckBox.checked = !e.target.checked;
			}
			privateFns.updateUrl();
		};
		pointMarkCheckBox.onclick = function(e){
			//var urlBase = {partList: {}, addPart: {}};
			urlBase.partList.pointMark = "&lat=" + globals.map.getView().getCenter()[1]  + "&lon=" + globals.map.getView().getCenter()[0]; 
			urlBase.addPart.pointMark = e.target.checked;
			if(e.target.checked){					
				urlBase.addPart.point = !e.target.checked;
				pointCheckBox.checked = !e.target.checked;
			}
			privateFns.updateUrl();
		};
		minCheckBox.onclick = function(e){
			urlBase.partList.min = "&min=true"; 
			urlBase.addPart.min = e.target.checked;
			privateFns.updateUrl();
		};
		modeCheckBox.onclick = function(e){
			urlBase.addPart.mode = e.target.checked;
			privateFns.updateUrl();
		};
		
		var container = creator.createDiv({css: "share-btn-ct"});
		container.appendChild(creator.createA({id: "share-email", title: "Del via epost", href: "mailto:?subject=planinnsyn.oslo.no&amp;body=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "icon-Epost"}), ariaLabel: "Del lenke til planinnsyn via epost"}));
		container.appendChild(creator.createA({id: "share-twitter", title: "Del via twitter", href: "http://twitter.com/share?url=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "fa fa-twitter"}), ariaLabel: "Del lenke til planinnsyn via twitter"}));
		container.appendChild(creator.createA({id: "share-facebook", title: "Del via facebook", href: "http://facebook.com/sharer.php?u=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "fa fa-facebook"}), ariaLabel: "Del lenke til planinnsyn via facebook"}));
		
		var copyButton = creator.createButton({id: "copy-link", text: "Kopier lenke"});
		copyButton.onclick = function(){
			var doc = document, text = doc.getElementsByClassName("permalink")[0];
			var range, select = true;
			if (doc.body.createTextRange) {
				range = doc.body.createTextRange();
				range.moveToElementText(text);
				range.select();
			} else if (window.getSelection) {
				var selection = window.getSelection();
				range = doc.createRange();
				range.selectNodeContents(text);
				selection.removeAllRanges();
				selection.addRange(range);
			} else {
				console.log("tekst selektering støttes ikke");
				select = false;
			}
			if (select) {
				if (doc.execCommand("copy")) {
					alert("Lenken er kopiert");
				} else {
					alert("Nettleseren din støtter ikke automatisk kopiering. Kopier lenken manuelt.");
				}
			}
		};
		container.appendChild(copyButton);
		el.appendChild(container);
		var closeButton = creator.createButton({css: "close-me hide-me", ariaLabel: "Lukk delemeny", text: "Lukk"});
		closeButton.onclick = function(){
			$("#share-page").hide(250);
		};
		el.appendChild(closeButton);
		return el;
	},
	createHelpArticle: function(elm){
		var article = creator.createArticle({});
		elm.text.forEach(function(p){
			if(p.paragraph){
				article.appendChild(creator.createParagraph({text:p.paragraph}));
			}else if(p.h4){
				article.appendChild(creator.createH4({text:p.h4}));				
			}else if(p.ul){
				article.appendChild(creator.createUl({listItems:p.ul}));	
			}
		})
		return article;
	},
	helpMenu: function(config) {
		var el = creator.createDiv({id: "help-page", css: "drop-downs floating-win"});
		el.setAttribute("data-enhance", "false");
		
		var header = creator.createHeader({});
		var btn = creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul tips"});
		btn.appendChild(creator.createIcon({css: "icon-Close"}));
		btn.onclick = function(){
			$("#help-page").hide();
			$("#planinnsyn-hjelp").toggleClass("drop-down-row-active");
			$("#planinnsyn-hjelp").find("i").toggleClass("icon-Menu").toggleClass("icon-Close");
		};
		header.appendChild(btn);
		el.appendChild(header);
		
		var content = creator.createDiv({css: "content"});
		config.forEach(function(elm){
			if(elm.type === "article"){
				var container = creator.createDiv({});
				container.appendChild(privateFns.createHelpArticle(elm));
				content.appendChild(container);
			}else if(elm.type === "helpTopic"){
				var container = creator.createDiv({id: "help-topic-"+elm.id, css: "help-topic"});
				var helpTopicBtn = creator.createButton({text: elm.header, css:"btn btn-topmenu btn-noborder", ariaLabel: elm.ariaLabel});
				helpTopicBtn.onclick = function(){
					if($("#"+ elm.id +"article").is(":visible")) {
						$("#"+ elm.id +"article").hide(250);
						$("#help-topic-" + elm.id).find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
					}else{
						$(".help-topic").find("article").hide(250);
						$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
						$("#"+ elm.id +"article").show(200);
						$("#help-topic-" + elm.id).find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
					}
				};
				helpTopicBtn.appendChild(creator.createIcon({css: "icon-Chevron-down "+ "tipsmenu-expander"}));
				container.appendChild(helpTopicBtn);
				let article = privateFns.createHelpArticle(elm);
				article.id = elm.id + "article";
				container.appendChild(article);
				content.appendChild(container);
				if(elm.addAdditional){
					elm.addAdditional(article);
				}
			}else if(elm.type === "feedback"){
				//<!--Gi tilbakemelding-->
				var tilbakemelding = creator.createDiv({css: "Help-topic", id: "feedback"});
				var tilbakemeldingBtn = creator.createButton({ariaLabel: elm.ariaLabel, css: "user-message-intranett", text: "<a>"+ elm.header +" </a>"});
				tilbakemeldingBtn.appendChild(creator.createIcon({css: "glyphicon glyphicon-comment"}));
				tilbakemeldingBtn.onclick = function () {
					var url = elm.intranettUrl;
					window.location.href = encodeURI(url);
				};
				tilbakemelding.appendChild(tilbakemeldingBtn);

				var tilbakemeldingBtnInternett = creator.createButton({ariaLabel: elm.ariaLabel, text: "<a>"+ elm.header +" </a>", css: "user-message-internett"});
				tilbakemeldingBtnInternett.appendChild(creator.createIcon({css: "icon-new-window"}));
				tilbakemeldingBtnInternett.onclick = function () {
					window.open(elm.internettUrl, "_blank");
				};
				tilbakemelding.appendChild(tilbakemeldingBtnInternett);
				
				content.appendChild(tilbakemelding);
			}
		});
		// <!-- Hvordan bruke verktøy -->
		var tools = creator.createDiv({id: "help-topic-tools", css: "help-topic"});
		var toolsButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan du bruker verktøy", id: "tool-info-btn", text: "Hvordan bruke verktøy"});
		toolsButton.onclick = function(){
			if($("#toolArticle").is(":visible")) {
				$("#toolArticle").hide(250);
				$("#help-topic-tools").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#toolArticle").show(200);
				$("#help-topic-tools").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		toolsButton.appendChild(creator.createIcon({css:"icon-Chevron-down tipsmenu-expander"}));
		tools.appendChild(toolsButton);
		var toolArticle = creator.createArticle({id: "toolArticle"});
		toolArticle.appendChild(creator.createH4({text: "Hvordan bruke verktøy?"}));
		var row  = creator.createDiv({css: "help-topic-tool-row"});
		var img  = creator.createDiv({css: "help-topic-tool-img", text: '<span class = "icon-Minus-sign"></span>'});
		var desc = creator.createDiv({css: "help-topic-tool-desc", text: "Zoom ut et nivå"});
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class = "icon-Plus-sign"></span>';
		desc.innerHTML = "Zoom inn et nivå";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class= "glyphicon glyphicon-globe"></span>';
		desc.innerHTML = "Zoomer til hele kartet";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		img.innerHTML = "";
		
		img.innerHTML = '<span class= "glyphicon glyphicon-erase"></span>';
		desc.innerHTML = "Fjern tegninger, målinger og markering av eiendom og planer.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		for(var plug in globals.registeredPlugins){
			var current = globals.registeredPlugins[plug];
			if(current.userGuide){
				row = row.cloneNode(true);
				row.innerHTML = "";
				row.id = "tool-info-" + current.id;
				img = img.cloneNode(true);
				desc = desc.cloneNode(true);
				img.innerHTML = "";
				
				if(current.userGuide.img.type === "icon"){
					img.innerHTML = '<span class= "' + current.userGuide.img.className + '"></span>';
				}else if(current.userGuide.img.type === "text"){
					img.innerHTML = '<span>'+ current.userGuide.img.className +'</span>';
				}
				desc.innerHTML = current.userGuide.text;
				row.appendChild(img);
				row.appendChild(desc);
				row.className += current.userGuide.className ? " " +current.userGuide.className : "";
				toolArticle.appendChild(row);
			}
		}
		
		tools.appendChild(toolArticle);
		content.insertBefore(tools, content.lastChild);
		
		//<!--Slett nettleserdata-->		
		var storage = creator.createDiv({css: "help-topic"});
		var storageButton = creator.createButton({css: "close-me hide-me", ariaLabel: "vis informasjon om vilkår for bruk av tjenesten", text: "Tilbakestill instillinger"});
		storageButton.onclick = function(){
			$.each(localStorage, function (obj) {
				if (obj.indexOf("planinnsyn") >= 0) {
					localStorage.removeItem(obj);
				}
				$("#hideSketchTip").attr("checked", false);
				$("#hideMeasureTip").attr("checked", false);
			});
			$("#hide-sketch-tip").prop("checked", false);
			$("#hide-measure-tip").prop("checked", false);
			alert("Lokale innstillinger har blitt slettet.");
		};
		storage.appendChild(storageButton);
		content.insertBefore(storage, content.lastChild);
		
			
		el.appendChild(content);
		
		return el;
	},
	addTopMenuItems: function(topMenuItems, intranett){
		var target = $(".drop-down-link-menu");
		topMenuItems.forEach(function (item) {
			target.prepend(privateFns.addTopMenuItem(item));
		});
		var smallScreenButton = creator.createButton({css: "top-menu-button small-screen", ariaLabel: "Se flere valg"});
		smallScreenButton.style.color = "#2A2859";
		smallScreenButton.appendChild(creator.createIcon({css: "glyphicon glyphicon-option-vertical"}));
		smallScreenButton.onclick = function(){
			var target = $(".drop-down-link-menu");
			$(".drop-downs").hide();
			if ($(window).width() < 767) {
				$("#searchinput").hide();
			}
			target.toggleClass("show-collapsible");
		};
		$("#middleDiv").prepend(smallScreenButton);
	},
	addTopMenuItem: function (item, intranett) {
		var itemElement = creator.createButton({});
		if (item.type === "button") {
			itemElement.type = "button";
			itemElement.id = item.id;
			itemElement.className = "drop-down-row";
			itemElement.title = item.toolTip;
			itemElement.innerHTML = "";
			itemElement.innerHTML += item.innerHTML;
			if (item.icon) {
				itemElement.innerHTML += "<i class='" + item.iconClass + "'></i>";
				if (item.iconHTML) {
					itemElement.innerHTML += "<span class='icon-text'>" + item.iconHTML + "</span>";
				}
				itemElement.innerHTML += " ";
			}
			if (item.svg) {
				itemElement.innerHTML += "<img src='" + item.iconClass + "'></img>";
				if (item.iconHTML) {
					itemElement.innerHTML += "<span class='icon-text'>" + item.iconHTML + "</span>";
				}
				itemElement.innerHTML += " ";
			}
			if(typeof item.onclick === "function") {
				itemElement.onclick = item.onclick;
			}else {
				itemElement.onclick = clickFns[item.onclick];
			}
			if(item.contentPage){
				$("#map").append(privateFns[item.contentPage](item.content));
			}
		}
		return itemElement;
	},
	createWKTStringFromFeatures: function () {
		var wktString = "";
			for (const [key, plug] of Object.entries(globals.registeredPlugins)) {
				var shareString = "", paramName;
				if(plug.share){
					shareString += plug.share();
					paramName = plug.id;
				}
				if (shareString && shareString.length > 0) {
					shareString = "&" + paramName + "=" + encodeURIComponent(shareString);
				}
				wktString += shareString;
			}
		return wktString;
	},
	updateUrl: function () {
		//var urlBase = {partList: {}, addPart: {}};
		let siteUrl = "http://" + location.hostname + location.pathname;
		for (var key in urlBase.addPart){
			if(urlBase.addPart[key]){
				siteUrl += urlBase.partList[key];
			}
		}
		let wktString = privateFns.createWKTStringFromFeatures();
		if(wktString && wktString.length > 0){				
			siteUrl += wktString;
		}
		
		var permalink = creator.createA({css: "permalink"});
		permalink.innerHTML = siteUrl;
		permalink.href = siteUrl;
		
		$(".share-url").html(permalink);
		
	},
	togglePermalinkSharingBtns: function (siteUrl) {
		if (siteUrl.length >= 2000) {
			siteUrl = "Url-en er for lang på grunn av for mange tegninger, målinger eller kommentarer";
			$(".user-message-intranett").hide();
			$("#copy-link").hide();
			$("#share-email").hide();
			$("#share-twitter").hide();
			$("#share-facebook").hide();
		} else if (siteUrl.length >= 1840) {
			$("#copy-link").show();
			$("#share-email").hide();
			$("#share-twitter").hide();
			$("#share-facebook").hide();
			if (intranett) {
				$("#share-page").find("span").html("Url-en er for lang til deling via epost. Du kan fortsatt kopiere url-en manuelt og dele den.");
			} else {
				$("#share-page").find("span").html("Url-en er for lang til deling via epost, twitter og facebook. Du kan fortsatt kopiere url-en manuelt og dele den.");
			}
		} else if (siteUrl.length > 140) {
			$("#copy-link").show();
			$("#share-email").show().attr("href", "mailto:?subject=planinnsyn.oslo.no&body=" + encodeURIComponent(siteUrl) + "%0D%0A%0D%0APlan- og bygningsetaten");
			$("#share-twitter").hide();
			$("#share-facebook").show().attr("href", "http://facebook.com/sharer.php?u=" + encodeURIComponent(siteUrl));
			$("#share-page").find("span").html("Del via:");
		} else {
			$("#copy-link").show();
			$("#share-email").show().attr("href", "mailto:?subject=planinnsyn.oslo.no&body=" + encodeURIComponent(siteUrl) + "%0D%0A%0D%0APlan- og bygningsetaten");
			$("#share-twitter").show().attr("href", "http://twitter.com/share?url=" + encodeURIComponent(siteUrl));
			$("#share-facebook").show().attr("href", "http://facebook.com/sharer.php?u=" + encodeURIComponent(siteUrl));
			$("#share-page").find("span").html("Del via:");
		}

		if (intranett) {
			$("#share-twitter").hide();
			$("#share-facebook").hide();
		}
		return siteUrl;
	},
};

clickFns = {
	shareClick: function(){
		$("#share-page").toggle(250);
		$("#help-page").hide(250);
		var permalink = creator.createA({css: "permalink"});
		var lyrArray = [];
		globals.forAllLayers(globals.map, function (l) {
			if (l.getVisible() && l.get("group") !== "hidden" && l.get("displayInLayerMenu") && !l.get("layers") && $("#"+l.values_.layerId)[0]) {
				lyrArray.push(l.values_.layerId);
			}
		});
		urlBase.partList.list = globals.list ? "?list=" + globals.list : "?";
		urlBase.addPart.list = true;
		
		urlBase.partList.mode = "&mode=" + lyrArray.join(",");
		urlBase.addPart.mode = true;
		
		urlBase.partList.point = "&north=" + globals.map.getView().getCenter()[1]  + "&east=" + globals.map.getView().getCenter()[0];
		urlBase.addPart.point = true;
		
		urlBase.partList.pointMark = "&lat=" + globals.map.getView().getCenter()[1]  + "&lon=" + globals.map.getView().getCenter()[0];
		urlBase.addPart.pointMark = false;
		
		privateFns.updateUrl();
	},
};

export default {
	initiate: function(items, intranett){
		intranett = intranett; 
		privateFns.addTopMenuItems(items);
		if (intranett) {
			$(".user-message-intranett").show();
		} else {
			$(".user-message-internett").show();
		}
	},
};

